const register = {
  loginCredentials: "Credenziali di accesso", // translated
  companyInformation: "Informazioni aziendali", // translated
  contactDetails: "Dettagli del contatto", // translated
  businessName: "Nome commerciale", // translated
  businessAddress: "Recapito di lavoro", // translated
  registrationCode: "Codice di registrazione", // translated
  businessRegistrationNumber: "Numero di registrazione commerciale", // translated
  websiteUrl: "URL del sito", // translated
  mobilePhone: "Cellulare", // translated
  regionStateProvince: "Regione/Stato/Provincia", // translated
  legalTitle: "Titolo legale", // translated
  city: "Città", // translated
  postalCode: "Codice Postale", // translated
  registrationSuccess: "Registrazione avvenuta.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Attendi qualche istante e verrai reindirizzato alla home page.", // translated
  usernameEmail: "Nome utente (e-mail)", // translated
  password: "Password", // translated // translated 
  verifyPassword: "Verifica password", // translated
  documents: "Documenti", // translated
  termsAndConditionsSection: "Termini e condizioni", // translated
  certificateOfIncorporation: "Certificato di costituzione", // translated
  acceptTermsAndConditions: "Accetta termini e condizioni", // translated
  country: "Paese", // translated
  brandName: "Marchio", // translated
  register: "Registrati", // translated
  isRequired: "È obbligatorio", // translated
  passwordMin8Chars: "Deve contenere almeno 8 caratteri", // translated
  passwordRequiresDigit: "Deve contenere almeno 1 cifra", // translated
  passwordRequiresLowercase: "Deve contenere almeno 1 lettera minuscola", // translated
  passwordRequiresUppercase: "Deve contenere almeno 1 lettera maiuscola", // translated
  passwordRequiresSpecialChar: 'Deve contenere almeno 1 carattere speciale (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Carica file", // translated
  filename: "Nome file:", // translated
  fileType: "Tipo:", // translated
  fileSize: "Dimensione:", // translated
  maxFileSize10Mb: "Max: 10 MB", // translated
  supportedFileTypes: "Tipi di file supportati:", // translated
  showPassword: "Mostra password", // translated
  hidePassword: "Nascondi password", // translated
  notAvailable: "N/D", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "es. +393331234567", // translated
  websiteUrlPlaceholder: "http://www.esempio.com", // translated
  loading: "Caricamento...", // translated
  uploadingDocument: "Caricamento documento...", // translated
  percentUploaded: "{{percent}}% caricato", // translated
  registrationSuccessful: "Registrazione completata.", // translated
  failedToUploadDocument: "Caricamento documento non riuscito.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} deve essere più lungo di {{min}} caratteri", // translated
  fieldMustBeValidEmail: "{{field}} deve essere un'e-mail valida", // translated
  fieldPasswordMinLength: "{{field}} deve contenere almeno 8 caratteri", // translated
  fieldPasswordRequiresDigit: "{{field}} deve contenere almeno 1 cifra", // translated
  fieldPasswordRequiresLowercase: "{{field}} deve contenere almeno 1 lettera minuscola", // translated
  fieldPasswordRequiresUppercase: "{{field}} deve contenere almeno 1 lettera maiuscola", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} deve contenere almeno 1 carattere speciale (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} non corrisponde a {{otherField}}", // translated
  fieldBetweenLength: "{{field}} deve essere tra {{min}} e {{max}} caratteri", // translated
  postalCodeBetweenLength: "{{field}} deve essere tra {{min}} e {{max}} caratteri", // translated
  invalidUrlFormat: "Formato URL non valido", // translated
  invalidEmailFormat: "Formato e-mail non valido", // translated
  emailMustMatchUsername: "l'e-mail deve essere uguale al nome utente (e-mail)", // translated
  mobilePhoneIsRequired: "Il telefono cellulare è obbligatorio", // translated
  certificateFileTooLarge: "Il certificato di costituzione è troppo grande", // translated
  termsMustBeAccepted: "I termini e condizioni devono essere accettati", // translated
};


export default register;
